import type { DecisionEngineDestinationDefinition } from "./definition";
import {
  getMappingForUserColumn,
  hightouchMappingWithTags,
} from "./sync-config-helpers";

const ACC_ADDRESS_FIELD: Record<string, string> = {
  email: "Email",
  sms: "Telephone",
};

export const accDefinition: DecisionEngineDestinationDefinition = {
  destinationType: "adobe-campaign-classic",
  category: "batch",
  generateSyncConfig: ({
    channelType,
    channelConfig,
    isPreview,
    messageTags,
  }) => {
    const { channelDataColumn, customResourceName } = channelConfig;
    const addressField = ACC_ADDRESS_FIELD[channelType] ?? "Email";

    if (!customResourceName) {
      throw new Error(
        "customResourceName is required in channel config for ACC object syncs",
      );
    }

    return {
      type: "object",
      object: "customResources",
      mode: "upsert",
      customResourceName,
      externalIdMapping:
        // During preview, the user-entered address is in external_id.
        // During real sends, pull it from the configured user column.
        isPreview || !channelDataColumn
          ? { from: "external_id", to: addressField }
          : getMappingForUserColumn(
              channelDataColumn.toLowerCase(),
              addressField,
            ),
      mappings: [hightouchMappingWithTags(messageTags)],
    };
  },
  // The custom-resources sync reads `parallelization` at runtime (its
  // checkpoint batch is 100 * parallelization); no batch-size key exists, so
  // batch size is not tunable.
  syncTuning: {
    modes: ["insert", "update", "upsert"],
    parallelization: { max: 100 },
  },
};
